
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/ai",
      function () {
        return require("private-next-pages/cases/ai/index.tsx");
      }
    ]);
  